import $ from 'jquery';

import { CONNECTION, RABBIT_CONNECTION, ROLE } from '../const';
import * as socketSubscriberService from '../services/socketConnection/socketSubscriberService';
import { getUserId, getUserRole } from '../services/jwt/jwtService';
import { API_STATUS } from '../services/api/apiConst';
import { REDUCER } from '../reducers/reducersConst';
import { isElectronApp } from '../services/crossPlatform/crossPlatformService';
import { ApiLoaderService } from '../services/apiLoader/apiLoaderService';
import { synchronizeContentDownload } from './contentActions';
import { getLogger } from '../services/logger';
import { notifyDisconnection } from '../electron/windowManager';
import * as contentActions from './contentActions';

const debug = getLogger('actions:connectionActions');

export let setConnectionStatus = status => {
  return {
    type: REDUCER.CONNECTION.STATUS,
    status
  };
};

export let setConnectionStatusRabbitState = statusRabbitState => {
  return {
    type: REDUCER.CONNECTION.STATUS_RABBIT_STATE,
    statusRabbitState
  };
};

export let setConnectionAttempts = attempts => {
  return {
    type: REDUCER.CONNECTION.ATTEMPTS,
    attempts
  };
};

let setConnectionTrying = trying => {
  return {
    type: REDUCER.CONNECTION.TRYING,
    trying
  };
};

let setIsLoadingData = isLoadingData => {
  return {
    type: REDUCER.CONNECTION.IS_LOADING_DATA,
    isLoadingData
  };
};

export let checkConnectionStatus = fromEvent => {
  return (dispatch, getState) => {
    let state = getState();
    let { trying } = state.connection;

    // Forbid multiple calls
    if (trying) {
      return;
    }

    dispatch(setConnectionTrying(true));

    return new Promise(resolve => {
      // helpers
      let finishLoop = () => {
        if (checkAllInterval) clearInterval(checkAllInterval);
        dispatch(setConnectionTrying(false));
        return resolve();
      };

      let checkStatusHelper = () => {
        let state = getState();
        let { attempts, status } = state.connection;
        const oldStatusGeneral = status.general;
        if (attempts > CONNECTION.TIMES_RECONECT) {
          return finishLoop(checkAllInterval, resolve);
        }
        attempts++;
        dispatch(setConnectionAttempts(attempts));
        return dispatch(checkAllStatus()).then(connectionStatus => {
          if (isElectronApp() && !fromEvent && attempts === 1) {
            notifyDisconnection();
          }

          dispatch(setConnectionStatus(connectionStatus));

          if (!connectionStatus.online && isElectronApp()) {
            dispatch(contentActions.pauseContentBooksDownloads());
          }

          if (connectionStatus.general) {
            dispatch(setConnectionAttempts(0));
            if (!oldStatusGeneral) {
              dispatch(loadAllDataOfApis());
            }
            return finishLoop(checkAllInterval, resolve);
          }
        });
      };

      checkStatusHelper();
      let checkAllInterval = setInterval(checkStatusHelper, CONNECTION.MILS_TO_RECONNECT);
    });
  };
};

export const forceTryToConnect = () => {
  return dispatch => {
    dispatch(checkConnectionStatus());
  };
};

export const manualTryToConnect = fromEvent => {
  return dispatch => {
    dispatch(setConnectionAttempts(0));
    dispatch(checkConnectionStatus(fromEvent));
  };
};

const checkAllStatus = () => {
  return (dispatch, getState) => {
    const rabbitRequired = getState().router.inClassroom;
    const connectionStatus = getState().connection.status;

    const getStatuses = async () => {
      connectionStatus.network = await checkNetworkStatus();
      connectionStatus.backend = await checkBackendStatus();
      connectionStatus.rabbit = await checkRabbit(getState);
      connectionStatus.online = connectionStatus.network && connectionStatus.backend;
      connectionStatus.general =
        connectionStatus.network && connectionStatus.backend && (connectionStatus.rabbit || !rabbitRequired);
      if (window.Cypress) {
        console.log('[Cypress Debug] checkAllStatus:', JSON.stringify({
          network: connectionStatus.network,
          backend: connectionStatus.backend,
          rabbit: connectionStatus.rabbit,
          online: connectionStatus.online,
          general: connectionStatus.general,
          rabbitRequired
        }));
      }
      return connectionStatus;
    };

    return getStatuses();
  };
};

const checkNetworkStatus = () => {
  return new Promise(resolve => {
    let createCORSRequest = (method, url) => {
      let xhr = new XMLHttpRequest();
      if ('withCredentials' in xhr) {
        // Most browsers.
        xhr.open(method, url, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        // IE8 & IE9
        xhr = new XDomainRequest();
        xhr.open(method, url);
      } else {
        // CORS not supported.
        xhr = null;
      }
      return xhr;
    };

    let url = API_STATUS;
    let method = 'GET';
    let xhr = createCORSRequest(method, url);

    xhr.onload = () => {
      resolve(true);
    };

    xhr.onerror = err => {
      resolve(false);
    };

    xhr.send();
  });
};

const checkBackendStatus = function() {
  return checkPing(API_STATUS)
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};

const checkRabbit = getState => {
  return new Promise(resolve => {
    socketSubscriberService.init();
    const rabbitState = getState().connection.statusRabbitState;

    resolve(rabbitState === RABBIT_CONNECTION.OK);
  });
};

const checkPing = host => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: host,
      success: resolve,
      error: reject
    });
  });
};

export const loadAllDataOfApis = () => {
  return (dispatch, getState) => {
    if (!isElectronApp()) return;

    dispatch(setIsLoadingData(true));

    // The pourpose of this timeout is wait for the school customer request on page reload
    // and avoid multiple requests of this resource
    setTimeout(() => {
      let state = getState();
      let role = getUserRole(state);
      let userId = getUserId(state);
      let apiLoaderService = ApiLoaderService.getInstance();
      apiLoaderService.setLoadActivated(true);
      if (role === ROLE.INSTRUCTOR) {
        return apiLoaderService
          .callDataByTeacher(userId)
          .then(() => {
            dispatch(setIsLoadingData(false));
            dispatch(synchronizeContentDownload(userId));
          })
          .catch(error => {
            debug.error('[loadAllDataOfApis] %s', error);
            dispatch(setIsLoadingData(false));
          });
      } else if (role === ROLE.STUDENT) {
        return apiLoaderService
          .callDataByStudent(userId)
          .then(() => {
            dispatch(setIsLoadingData(false));
            dispatch(synchronizeContentDownload(userId));
          })
          .catch(error => {
            debug.error('[loadAllDataOfApis] %s', error);
            dispatch(setIsLoadingData(false));
          });
      }
    }, 1000);
  };
};
